import { OnInit } from '@angular/core';
import { ToastModule } from 'primeng/toast';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';

// import { AppRoutingModule } from './app-routing.module';
// import { SharedModule } from './shared/shared.module';
import { HttpClientModule } from '@angular/common/http';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { EditorModule } from '@tinymce/tinymce-angular';
import { TooltipModule } from 'primeng/tooltip';
import { ClickOutsideModule } from 'ng-click-outside';
import { FormsModule } from '@angular/forms';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { FullCalendarModule } from '@fullcalendar/angular';
import { MultiSelectModule } from 'primeng/multiselect';
import { DropdownModule } from 'primeng/dropdown';
import { DialogModule } from 'primeng/dialog';
// ////import { AppRoutingModule } from './app-routing.module';
//import { SharedModule } from './shared/shared.module';
import { Component } from '@angular/core';


import { AppService } from '../../../app/app.service';
import { IonAccordion, IonicModule } from '@ionic/angular';
import { PickListModule } from 'primeng/picklist';

@Component({
  standalone:true,
  imports:[

    //BrowserModule,
    //BrowserAnimationsModule,
    // //SharedModule,
    HttpClientModule,
    ToastModule,
    EditorModule,
    ProgressSpinnerModule,
    TooltipModule,
    // ClickOutsideModule,
    FullCalendarModule,
    FormsModule,
    // NgxMaterialTimepickerModule,
    // AppRoutingModule,
    MultiSelectModule,
    DropdownModule,
    CommonModule,
    DialogModule,
    IonicModule,
    PickListModule
    // ProviderModule
],
  selector: 'app-table-columns',
  templateUrl: './table-columns.component.html',
  styleUrls: ['./table-columns.component.scss'],
})

export class TableColumnsComponent implements OnInit {
  list1: any[];
  list2: any[];
  columnsPopup =false;
  openColumnsPopUp=false;
  constructor(
  public appService: AppService,
   ) { }
  ngOnInit(): void {
    this.list1 = [
      { values:"Location Interest"},
      { values:"Budget"} ,
      { values:"Timeframe"},
      { values:"Criteria"},
      { values:"Property Type"},
      { values:"Main Features"} ,
      { values:"Qualified"},
      { values:"NextFollow Up"},
      { values:"Last"},
      { values:"Follow Up"} ,
      { values:"Last Login"} ,
      { values:"Source"},
      { values:"Campaign"},
      { values:"Owner"},
      { values:"Lender" },
    ];
    this.list2 = [];
    this.appService.columnspopup.subscribe(res => {
      this.openColumnsPopUp = res;
    });
  }
}
